import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: {
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '2fr 4fr 3fr 3fr 4fr 4fr 1fr',
    paddingLeft: 12
  }
}))
export default useStyles
